import Page from './Page';
import Component from 'vue-class-component';

import template from './MerchandiseDetail.vue.html';
import GuestDatePicker from '../common/GuestDatePicker.vue';
import TimePicker from '../common/TimePicker.vue';
import MerchandiseCarousel from '../common/merchandise/MerchandiseCarousel.vue';
import HeaderComponent from './Header.vue';
import { Schedule } from '../common/merchandise/Types';
import { Image } from './MerchandiseCategories.vue';
import { MerchandiseItem } from './app';
import { MobileOrderCart } from './MoblieOrderCart';
import { Order } from '../common/merchandise/Order';

@Component({
    template,
    components: {
        GuestDatePicker,
        MerchandiseCarousel,
        TimePicker,
        HeaderComponent,
    },
})
export default class MerchandiseDetail extends Page {
    get merchandiseItem(): MerchandiseItem | null {
        const id = Number(this.app.query.merchandiseItemId);
        return (
            this.app.mobile_order_merchandises.find((m) => m.id === id) ?? null
        );
    }

    get images(): readonly Image[] {
        const item = this.merchandiseItem;
        if (!item) return [];
        return item.image_urls.map((url) => ({
            merchandise_item_id: item.id,
            filepath: url,
        }));
    }

    order: Order | null = null;
    use_date: string | null = null;

    async created() {
        await this.app.fetchMerchandises();
        const item = this.merchandiseItem;
        if (!item) {
            alert(this._('unable_merchandise_alert'));
            this.app.setPage('MerchandiseCategories');
            return;
        }
        const id = item.use_dates?.[0].schedules?.[0].rooms?.find(
            (room) => room.stock
        )?.id;
        if (this.getDates().length === 1) this.use_date = this.getDates()[0];
        const reservesRoom = this.app.reserves_rooms[0];
        this.order = Order.asDefault(
            id ?? reservesRoom.id,
            item,
            this.app.mobile_order_merchandises
        );

        await this.$nextTick();
        this.$forceUpdate();
    }

    availableReservesRooms() {
        if (!this.merchandiseItem) return [];
        if (this.merchandiseItem.sales_unit === 'quantity_unit')
            return this.app.reserves_rooms.filter((rr) =>
                this.merchandiseItem?.plan_matched_reserves_room_ids.includes(
                    rr.id
                )
            );
        return this.app.reserves_rooms
            .filter((rr) =>
                this.order?.schedule?.rooms
                    ?.filter((room) => room.stock > 0)
                    .map((room) => room.id)
                    .includes(rr.id)
            )
            .filter((rr) =>
                this.merchandiseItem?.plan_matched_reserves_room_ids.includes(
                    rr.id
                )
            );
    }

    getDates() {
        return (
            this.merchandiseItem?.use_dates.map((use_date) => use_date.date) ??
            []
        );
    }

    getTimes() {
        const selectedUseDate = this.order?.useDate;
        return [selectedUseDate?.start_time, selectedUseDate?.end_time];
    }

    changeUseDate() {
        if (!this.order) return;
        this.order.useDate = this.merchandiseItem?.use_dates.find(
            (d) => d.date === this.order?.use_date
        )!;
        this.$forceUpdate();
    }

    changeSchedule(schedule: Schedule) {
        if (this.order) this.order.schedule = schedule;
        this.$forceUpdate();
    }

    reduceMerchandise() {
        this.order?.decrease();
        this.$forceUpdate();
    }
    addMerchandise() {
        this.order?.increase();
        this.$forceUpdate();
    }

    addOrder() {
        if (!this.use_date) return;
        if (!this.app.reserve) return;
        if (!this.order) return;
        this.order.use_date = this.use_date;
        const cart = new MobileOrderCart(
            this.app.reserve.id,
            this.app.mobile_order_merchandises
        );
        cart.save(this.order);
        this.app.setPage('MobileOrderApplication');
    }

    setCategory() {
        this.app.updateQuery({
            page: 'MerchandiseList',
            category: this.app.query.category,
        });
    }

    dateOption(date: string): string {
        const options: Intl.DateTimeFormatOptions = {
            weekday: 'short',
            month: 'long',
            day: 'numeric',
        };
        return new Date(date).toLocaleDateString(undefined, options);
    }

    scheduleInUseDate() {
        return (
            this.merchandiseItem?.use_dates.find(
                (use_date) => use_date.date === this.use_date
            )?.schedules || []
        );
    }

    changedUseDate() {
        if (!this.order) return;
        if (!this.use_date) return;
        this.order.use_date = this.use_date;
        this.order.useDate = this.merchandiseItem?.use_dates.find(
            (d) => d.date === this.use_date
        )!;
        this.$forceUpdate();
    }

    changedRoom() {
        if (!this.order) return;
        this.order.useDate = this.merchandiseItem?.use_dates.find(
            (d) => d.date === this.use_date
        )!;
        this.$forceUpdate();
    }

    unselectableRoom() {
        return !this.availableReservesRooms().some(
            (room) => room.id === this.order?.reserves_room_id
        );
    }
}
